let baseURL = '';

const envBaseURL = process.env.VUE_APP_BASE_URL;

if (envBaseURL) {
    baseURL = envBaseURL;
} else {
    baseURL = 'http://localhost:8080';
}

export { baseURL };